// [commons] widget

export enum DeviceTypeEnum {
  mobile = 'mobile',
  desktop = 'desktop',
}
